import { useEffect, useState } from "react";
import { hydrateQuiz } from "../domains/storage/QuizHydrate";
import { saveQuiz } from "../domains/storage/QuizSave";
import { PersistedStateV3 } from "../domains/storage/PersistSchema";

export function useQuizStorage() {
  const [initial, setInitial] = useState<PersistedStateV3 | null>(null);

  useEffect(() => {
    const data = hydrateQuiz();
    setInitial(data || null);
  }, []);

  const persist = (state: PersistedStateV3) => {
    saveQuiz(state);
  };

  return { initial, persist };
}
